import React from "react";

// reactstrap components
import {
  Container,
  Row,
  Col,
  Carousel,
  CarouselItem,
  CarouselIndicators,
} from "reactstrap";

// core components

const items = [
  {
    src: require("assets/img/carousel/logo_animated_lg.gif"),
    altText: "Ruma's Delights - (770) 617-8995",
    caption: ".",
  },
  {
    src: require("assets/img/carousel/Pan.png"),
    altText: "Pan",
    caption: "Welcome!!!",
  },
  {
    src: require("assets/img/carousel/PolaoPlate.png"),
    altText: "Polao-Roast",
    caption: "Polao-Roast",
  },
  {
    src: require("assets/img/carousel/SweetMix1.png"),
    altText: "Sweets",
    caption: "Sweets",
  },
  {
    src: require("assets/img/carousel/PattiesTriangle.jpg"),
    altText: "Snacks",
    caption: "Snacks",
  },
  {
    src: require("assets/img/curd.jpg"),
    altText: "Sweet Curd",
    caption: "Sweet Curd",
  },
  {
    src: require("assets/img/carousel/Birani.png"),
    altText: "Biryani",
    caption: "Biryani",
  },
  {
    src: require("assets/img/carousel/Balushai.png"),
    altText: "Balushai",
    caption: "Balushai",
  },
  {
    src: require("assets/img/carousel/RoastTable.png"),
    altText: "Catering",
    caption: "Catering",
  },
];

function CommonCarousel() {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [animating, setAnimating] = React.useState(false);
  const onExiting = () => {
    setAnimating(true);
  };
  const onExited = () => {
    setAnimating(false);
  };
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };
  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };
  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };
  return (
    <>
      <div id="carousel">
        <Container>
          <Row className="justify-content-center">
            <Col lg="8" md="12">
              <Carousel
                activeIndex={activeIndex}
                next={next}
                previous={previous}
              >
                <CarouselIndicators
                  items={items}
                  activeIndex={activeIndex}
                  onClickHandler={goToIndex}
                />
                {items.map((item) => {
                  return (
                    <CarouselItem
                      onExiting={onExiting}
                      onExited={onExited}
                      key={item.src}
                    >
                      <img src={item.src} alt={item.altText} width="500pt" height="325pt" />
                      <div className="carousel-caption d-none d-md-block">
                        <h5>{item.caption}</h5>
                      </div>
                    </CarouselItem>
                  );
                })}
                <a
                  className="carousel-control-prev"
                  data-slide="prev"
                  href="#pablo"
                  onClick={(e) => {
                    e.preventDefault();
                    previous();
                  }}
                  role="button"
                >
                  <i className="now-ui-icons arrows-1_minimal-left"></i>
                </a>
                <a
                  className="carousel-control-next"
                  data-slide="next"
                  href="#pablo"
                  onClick={(e) => {
                    e.preventDefault();
                    next();
                  }}
                  role="button"
                >
                  <i className="now-ui-icons arrows-1_minimal-right"></i>
                </a>
              </Carousel>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default CommonCarousel;
